import { useCallback } from 'react';
import { PrimaryButton, Layout } from "../components/index";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router"

const OrderComplete = () => {
    const dispatch = useDispatch()

    const goBackToTop = useCallback(() => {
        dispatch(push('/'))
    }, [dispatch])

    return (
        <Layout>
            <section style={{textAlign: 'center'}}>
                <div className='spacer-100' />
                <div className='spacer-100' />
                <p>ご注文ありがとうございました！</p>
                <div className='spacer-50' />
                <PrimaryButton label="ショッピングを続ける" operation={goBackToTop} />
                <div className='spacer-100' />
                <div className='spacer-100' />
            </section>
        </Layout>
    );
};

export default OrderComplete;